<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'Devices'"></navBox>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<div class="banner_el">
					<img src="../../assets/img/devices/banner_1.webp" />
					<div class="msg_box">Devices</div>
				</div>
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box">
				<van-icon name="wap-home" class="icon" color="#808080" size="20px" />
				<span>Home</span>
				<van-icon name="arrow" class="icon" color="#808080" size="18px" />
				<span style="color: #808080;">Devices</span>
			</div>
			<!--位置-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_main">
					<div
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
						class="top_box"
					>
						<div class="tit">Devices</div>
						<div class="txt">
							Developed and sold point-of-care diagnostic testing (POCT) instruments, Quantitative PCR Analysis System and Automatic Nucleic Acid Extractor, etc.
						</div>
					</div>
					<div v-if="deviceList.length > 0" class="list_box">
						<div
							data-aos="fade-up"
							data-aos-duration="400"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-once="true"
							v-for="(value, index) in deviceList"
							:key="index"
						>
							<div v-if="index %2 === 0" class="list_el">
								<div class="list_el_el">
									<div class="left">
										<img :src="webUrl + value.thumb" />
									</div>
									<div class="right">
										<div class="tit">{{ value.name }}</div>
										<div class="txt">{{ value.description }}</div>
										<div class="btn_box">
											<van-button color="#E37542" class="btn_el" @click="goInfo(value)">LEARN MORE</van-button>
										</div>
									</div>
								</div>
							</div>
							<div v-else class="list_el" style="background-color: #F8F8F8;">
								<div class="list_el_el">
									<div class="right">
										<div class="tit">{{ value.name }}</div>
										<div class="txt">{{ value.description }}</div>
										<div class="btn_box">
											<van-button color="#E37542" class="btn_el" @click="goInfo(value)">LEARN MORE</van-button>
										</div>
									</div>
									<div class="left">
										<img :src="webUrl + value.thumb" />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<contact></contact>
				</div>
			</div>
			<!--块2-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import contact from '@/component/contact/index_pc_component.vue'  //联系我们组件
import { UPURL } from '@/util/util';
export default {
	components:{
		navBox,
		footerBox,
		contact
	},
	data() {
		return {
			isLoading: true,  //界面loading
			deviceList: [{"id":5,"sort":2,"cate_id":"1,2","name":"GIS-1000 Dry Fluorescent Immunoassay Technology","custom":"gis-1000-dry-fluorescent-immunoassay-technology","thumb":"/storage/device/ca/c19d89bb6e9247ef8a072bd46333d3.png","description":"· Small and lightweight.\n· Fast and stable.","content":"","content2":"","is_tuijian":2,"create_time":1724816065,"update_time":1724986797,"cate_list":[{"id":1,"sort":1,"title":"CE","image":"/storage/DeviceCate/a3/d0c12cc503a3759906119d97694256.png","status":1,"create_time":1724637581,"update_time":1727138011},{"id":2,"sort":2,"title":"NMPA","image":"/storage/DeviceCate/38/0f6ea76890eca0544b0d6dfde19f8a.png","status":1,"create_time":1724637911,"update_time":1724821618}]},{"id":6,"sort":3,"cate_id":"1,2","name":"D1602 Real-time Fluorescence  Quantitative PCR Analysis System","custom":"d1602-real-time-fluorescence--quantitative-pcr-analysis-system","thumb":"/storage/device/ca/419f418b59dce89b965ce2ca29a89a.png","description":"· Dual channel and dual module design;\n· Realize independent operation of two different programs;\n· Small size, light weight, easy to carry.","content":"","content2":"","is_tuijian":2,"create_time":1724816112,"update_time":1724986800,"cate_list":[{"id":1,"sort":1,"title":"CE","image":"/storage/DeviceCate/a3/d0c12cc503a3759906119d97694256.png","status":1,"create_time":1724637581,"update_time":1727138011},{"id":2,"sort":2,"title":"NMPA","image":"/storage/DeviceCate/38/0f6ea76890eca0544b0d6dfde19f8a.png","status":1,"create_time":1724637911,"update_time":1724821618}]},{"id":4,"sort":4,"cate_id":"1,2","name":"BS0548 Automatic Nucleic Acid Extractor","custom":"bs0548-automatic-nucleic-acid-extractor","thumb":"/storage/device/1a/4e7abb1f29337a0f5537e873a77fef.png","description":"· Built-in UV disinfection module and negative pressure exhaust filter module, highly effective anti-pollution;\n· Open platform: suitable for multiple nucleic acid extraction schemes based on nano-magnetic beads;\n· Precise temperature control, fully reduce the volatilization of the eluent;\n· Automated nucleic acid extraction experiments, 48 samples can be processed at one time;\n· 1-10 level mixing speeds are available, custom mixing mode.","content":"<table border=\"0\" width=\"100%\" cellpadding=\"0\" cellspacing=\"0\"><tbody><tr><td><p>&nbsp;Product name</p></td><td><p>&nbsp;BS0548 Automatic Nucleic Acid Extractor</p></td></tr><tr><td><p>&nbsp;Model</p></td><td><p>&nbsp;BS0548</p></td></tr><tr><td><p>&nbsp;Sample throughput</p></td><td>&nbsp;1-48</td></tr><tr><td><p>&nbsp;Volume</p></td><td><p>&nbsp;20-1000μL</p></td></tr><tr><td><p>&nbsp;Consumable</p></td><td><p>&nbsp;96-well deep plate + magnetic rod cover</p></td></tr></tbody></table>","content2":"<p>测试1111</p>","is_tuijian":2,"create_time":1724813339,"update_time":1725517392,"cate_list":[{"id":1,"sort":1,"title":"CE","image":"/storage/DeviceCate/a3/d0c12cc503a3759906119d97694256.png","status":1,"create_time":1724637581,"update_time":1727138011},{"id":2,"sort":2,"title":"NMPA","image":"/storage/DeviceCate/38/0f6ea76890eca0544b0d6dfde19f8a.png","status":1,"create_time":1724637911,"update_time":1724821618}]},{"id":7,"sort":5,"cate_id":"1,2","name":"BE4000 Full-automatic Nucleic Acid Extraction WAcid Extraction","custom":"be4000-full-automatic-nucleic-acid-extraction-wacid-extraction","thumb":"/storage/device/b0/49ca4934edfa7eb505c4486220b908.png","description":"· 4-channel pipette arms with adjustable spacing;\n· 96 samples can be processed at once.","content":"","content2":"","is_tuijian":2,"create_time":1724816225,"update_time":1724986697,"cate_list":[{"id":1,"sort":1,"title":"CE","image":"/storage/DeviceCate/a3/d0c12cc503a3759906119d97694256.png","status":1,"create_time":1724637581,"update_time":1727138011},{"id":2,"sort":2,"title":"NMPA","image":"/storage/DeviceCate/38/0f6ea76890eca0544b0d6dfde19f8a.png","status":1,"create_time":1724637911,"update_time":1724821618}]}],  //  设备列表
			webUrl: UPURL,
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//点击查看详情
		goInfo(value) {
			let that = this;
			// let routeData = that.$router.resolve({name: "DeviceInfo", params: { deviceId: value.custom } });
			// window.open(routeData.href, '_blank');
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块2
	.block_2{
		.block_2_main{
			width: 1140px;
			margin: 0 auto;
		}
	}
	//块1
	.block_1{
		.block_1_main{
			.list_box{
				.list_el{
					.list_el_el{
						width: 1140px;
						margin: 0 auto;
						display: flex;
						align-items: center;
						padding: 50px 0;
						.right{
							flex: 1;
							padding: 0 40px;
							.btn_box{
								.btn_el{
									padding: 5px 20px 0 20px;
									font-size: 18px;
									border-radius: 6px;
								}
							}
							.txt{
								padding: 15px 0 35px 0;
								font-size: 18px;
								white-space: pre-wrap;
								line-height: 1.6;
							}
							.tit{
								font-size: 36px;
							}
						}
						.left{
							width: 450px;
							img{
								width: 100%;
							}
						}
					}
				}
			}
			.top_box{
				width: 1140px;
				margin: 0 auto;
				padding: 60px 0;
				.txt{
					padding-top: 15px;
					font-size: 20px;
				}
				.tit{
					font-size: 38px;
				}
			}
		}
	}
	//位置块
	.location_box{
		width: 1140px;
		margin: 0 auto;
		padding-top: 30px;
		.icon{
			top: 4px;
		}
		span{
			display: inline-block;
			padding: 0 5px;
			font-size: 16px;
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 1140px;
			position: absolute;
			z-index: 1;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: 60px;
		}
		img{
			width: 100%;
			min-width: 1140px;
		}
	}
}
</style>